<template>
  <VectorTileLayer
    v-if="source"
    :before="before"
    :layer="layerStyle"
    :layerId="layerId"
    :sourceId="sourceId"
    :source="source"
    @sourceLoaded="onSourceLoaded"
  />
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import VectorTileLayer from '@/components/map/mapbox-layers/VectorTileLayer.vue'
import { MAPVIEW_PREFIX } from '@/store/module-prefixes'
import { SET_MAP_VECTOR_TILE_STATE } from '@/store/mutation-types'

export default {
  name: 'LayerVectorTile',
  components: {
    VectorTileLayer
  },
  props: {
    before: {
      type: String,
      required: true
    },
    layerId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      // valueFromSlider: 0.8,
      sourceId: 'source-vector-tile',
      source: null,
      vectorTiles: [
        {
          id: 'vektorlager_1',
          url: 'mapbox://zynkadb.5yc5kpsv'
        }
      ]
    }
  },
  computed: {
    ...mapState(MAPVIEW_PREFIX, {
      selectedRealEstate: (state) => state.selectedRealEstate,
      currentMapVectorTileId: (state) => state.currentMapVectorTileId,
      mapVectorTileState: (state) => state.mapVectorTileState
      // currentDrawingTransparency: (state) => state.currentDrawingTransparency
    }),
    layerStyle() {
      return {
        id: this.layerId,
        source: this.sourceId,
        'source-layer': 'Layer1',
        type: 'line',
        paint: {
          'line-color': ['case', ['boolean', ['get', 'color'], false], '#969696', ['get', 'color']],
          'line-opacity': 1 // this.currentDrawingTransparency
        }
      }
    }
  },
  watch: {
    async currentMapVectorTileId() {
      this.loadVectorTile()
    }
  },
  async created() {
    this.loadVectorTile()
  },
  methods: {
    ...mapMutations(MAPVIEW_PREFIX, {
      setMapVectorTileState: SET_MAP_VECTOR_TILE_STATE
    }),
    async loadVectorTile() {
      try {
        this.source = null
        const vectorTile = this.vectorTiles.find(
          (vectorTile) => vectorTile.id === this.currentMapVectorTileId
        )
        if (!vectorTile) {
          this.setMapVectorTileState('hidden')
          return
        }
        const url = vectorTile.url
        this.source = {
          type: 'vector',
          url: url
          // tiles: [url]
        }
      } catch (e) {
        this.setMapVectorTileState('hidden')
        console.error(e)
      }
    },
    onSourceLoaded() {
      this.setMapVectorTileState('visible')
    }
  }
}
</script>
